import React from 'react';
import styled from 'styled-components';

import {
  VerticalMenuNavItem,
  VerticalMenuWrap,
  VerticalSubmenuNavItem,
} from '#/components/basic/Button/verticalMenu';
import MaterialSymbol from '#/components/basic/icons/MaterialSymbol';
import { useOwnVaultQuery } from '#/components/vaults/shared/utils';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
`;

function WalletDashboardMenu() {
  const ownVault = useOwnVaultQuery();
  return (
    <Wrap>
      <VerticalMenuNavItem
        to="/wallet/positions"
        icon={<MaterialSymbol icon="format_align_left" fontSize="inherit" />}
      >
        Positions
      </VerticalMenuNavItem>
      <VerticalMenuNavItem
        to="/wallet/open-orders"
        icon={<MaterialSymbol icon="list_alt" fontSize="inherit" />}
      >
        Open Orders
      </VerticalMenuNavItem>
      <VerticalMenuNavItem
        to="/wallet/history"
        icon={<MaterialSymbol icon="library_books" fontSize="inherit" />}
        partialHighlight
      >
        History
      </VerticalMenuNavItem>
      <VerticalMenuWrap>
        <VerticalSubmenuNavItem to="/wallet/history/trades">
          Trade History
        </VerticalSubmenuNavItem>
        <VerticalSubmenuNavItem to="/wallet/history/deposits-withdrawals">
          Deposits &amp; Withdrawals
        </VerticalSubmenuNavItem>
        {ownVault && (
          <VerticalSubmenuNavItem to="/wallet/history/vault-withdrawal-queue">
            Withdrawal Queue
          </VerticalSubmenuNavItem>
        )}
        <VerticalSubmenuNavItem to="/wallet/history/funding">
          Funding History
        </VerticalSubmenuNavItem>
      </VerticalMenuWrap>
      <VerticalMenuNavItem
        to="/wallet/api-keys"
        icon={<MaterialSymbol icon="cloud" fontSize="inherit" />}
      >
        API Keys
      </VerticalMenuNavItem>
      <VerticalMenuNavItem
        to="/wallet/session-keys"
        icon={<MaterialSymbol icon="vpn_key" fontSize="inherit" />}
      >
        Session Keys
      </VerticalMenuNavItem>
    </Wrap>
  );
}

export default WalletDashboardMenu;
